import React from "react";

import ReactEcharts from "echarts-for-react";

function StackedAreaChart({ data }) {
  const style = {
    height: "99%",
    width: "99%",
  };
  const option = {
    color: ["#F3AB9A", "#ab4129"],
    dataset: {
      source: data,
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
        label: {
          backgroundColor: "#6a7985",
        },
      },
      formatter: function (params) {
        let meses = [
          0,
          "Jan ",
          "Fev",
          "Mar",
          "Abr",
          "Mai",
          "Jun",
          "Jul",
          "Ago",
          "Set",
          "Out",
          "Nov",
          "Dez",
        ];

        const prof_total = `${params[0].value.total_teste_posi_prof}`.replace(
          /(\d{1,3})(?=(?:\d{3})+(?!\d))/g,
          "$1,"
        );
        const N_prof_total =
          `${params[0].value.total_teste_posi_nao_prof}`.replace(
            /(\d{1,3})(?=(?:\d{3})+(?!\d))/g,
            "$1,"
          );
        return (
          "<strong>" +
          meses[parseInt(params[0].value.mes.split("/")[0])] +
          " de " +
          params[0].value.ano +
          `</strong>${
            params.length === 2
              ? '<br /> Profissionais: <strong style="float:right;marginLeft:10px">' +
                prof_total +
                "</strong>" +
                '<br/>Não profissionais: <strong style="float:right;margin-left:10px">' +
                N_prof_total +
                "</strong>"
              : `${
                  params[0].seriesName === "Profissionais"
                    ? '<br /> Profissionais: <strong style="float:right;marginLeft:10px">' +
                      prof_total +
                      "</strong>"
                    : '<br/>Não Profissionais: <strong style="float:right;margin-left:10px">' +
                      N_prof_total +
                      "</strong>"
                }`
          }`
        );
      },
    },
    legend: {
      data: ["Não profissionais", "Profissionais"],
      textStyle: {
        fontSize: 9,
        fontWeight: "bold",
      },
      icon: "pin",
    },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "3%",
      top: "19%",
      containLabel: true,
    },
    xAxis: [
      {
        type: "category",
        boundaryGap: true,
        axisLabel: {
          fontSize: 10,
          fontWeight: 600,
        },
      },
    ],
    yAxis: [
      {
        type: "value",
        splitLine: {
          show: true,
        },
        axisLabel: { fontSize: 10, fontWeight: 600 },
      },
    ],
    series: [
      {
        name: "Profissionais",
        type: "line",
        stack: "总量",
        smooth: false,
        showSymbol: false,
        encode: {
          y: "total_teste_posi_prof",
        },
        emphasis: {
          focus: "none",
        },
        areaStyle: {
          opacity: 1,
        },
        lineStyle: {
          width: 0,
        },
      },
      {
        name: "Não profissionais",
        type: "line",
        stack: "总量",
        smooth: false,
        showSymbol: false,
        encode: {
          y: "total_teste_posi_nao_prof",
        },
        emphasis: {
          focus: "none",
        },
        areaStyle: { opacity: 1 },
        lineStyle: {
          width: 0,
        },
      },
    ],
  };
  return <ReactEcharts option={option} style={style} />;
}

export default StackedAreaChart;
